export const InitializationErrorCodes = {
  CONTAINER_NOT_FOUND: 'CONTAINER_NOT_FOUND',
  INITIALIZATION_ERROR: 'INITIALIZATION_ERROR', // catch-all for SDK initialization failures
} as const;

export const ValidationErrorCodes = {
  MISSING_PARAMETER: 'MISSING_PARAMETER', // required field missing
  INVALID_PARAMETER: 'INVALID_PARAMETER', // wrong type, enum mismatch, etc.
  INVALID_USAGE: 'INVALID_USAGE', // i.e. wrong browser context
} as const;

export const RequestErrorCodes = {
  UNAUTHORIZED: 'UNAUTHORIZED', // 401
  FORBIDDEN: 'FORBIDDEN', // 403
  NOT_FOUND: 'NOT_FOUND', // 404
  CONFLICT: 'CONFLICT', // 409
  REQUEST_TIMEOUT: 'REQUEST_TIMEOUT', // 408
  VALIDATION_ERROR: 'REQUEST_VALIDATION_ERROR', // 422
  SERVER_ERROR: 'SERVER_ERROR', // 5xx
  BAD_REQUEST: 'BAD_REQUEST', // 400 with generic or unknown reason
  REQUEST_ERROR: 'REQUEST_ERROR', // Catch-all fallback
  POLLING_ABORTED: 'POLLING_ABORTED',
  UNEXPECTED: 'UNEXPECTED',
} as const;

export const PaymentErrorCodes = {
  PAYMENT_CREATION_ABORTED: 'PAYMENT_CREATION_ABORTED',
  PAYMENT_CANCELLED: 'PAYMENT_CANCELLED', // the shopper deliberately cancelled the payment
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  RESUME_FAILED: 'RESUME_FAILED',
  TOKENIZATION_ERROR: 'TOKENIZATION_ERROR',
  IDEMPOTENCY_KEY_ALREADY_EXISTS: 'IDEMPOTENCY_KEY_ALREADY_EXISTS',
} as const;

export const ClientTokenErrorCodes = {
  MISSING_CLIENT_TOKEN: 'MISSING_CLIENT_TOKEN',
  INVALID_CLIENT_TOKEN: 'INVALID_CLIENT_TOKEN',
} as const;

export const VaultErrorCodes = {
  VAULT_ERROR: 'VAULT_ERROR',
  TOKENIZATION_ERROR: 'TOKENIZATION_ERROR',
} as const;

export type InitializationErrorCode =
  (typeof InitializationErrorCodes)[keyof typeof InitializationErrorCodes];
export type ValidationErrorCode =
  (typeof ValidationErrorCodes)[keyof typeof ValidationErrorCodes];
export type RequestErrorCode =
  (typeof RequestErrorCodes)[keyof typeof RequestErrorCodes];
export type PaymentErrorCode =
  (typeof PaymentErrorCodes)[keyof typeof PaymentErrorCodes];
export type ClientTokenErrorCode =
  (typeof ClientTokenErrorCodes)[keyof typeof ClientTokenErrorCodes];
export type VaultErrorCode =
  (typeof VaultErrorCodes)[keyof typeof VaultErrorCodes];

export type ErrorCode =
  | InitializationErrorCode
  | ValidationErrorCode
  | RequestErrorCode
  | PaymentErrorCode
  | ClientTokenErrorCode
  | VaultErrorCode;
